import { render } from "./Followers.vue?vue&type=template&id=53591c7c&scoped=true"
import script from "./Followers.vue?vue&type=script&lang=js"
export * from "./Followers.vue?vue&type=script&lang=js"

import "./Followers.vue?vue&type=style&index=0&id=53591c7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53591c7c"]])

export default __exports__